import { render, staticRenderFns } from "./BaseHoldBtn.vue?vue&type=template&id=fd1d2536&scoped=true"
import script from "./BaseHoldBtn.vue?vue&type=script&lang=js"
export * from "./BaseHoldBtn.vue?vue&type=script&lang=js"
import style0 from "./BaseHoldBtn.vue?vue&type=style&index=0&id=fd1d2536&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1d2536",
  null
  
)

export default component.exports